module.exports = __webpack_public_path__ + "img/Mark_Kay_2015.e3c03ede.png";